export default "__VITE_ASSET__BoPIJl23__"